<template>
  <v-card v-if="value" style="height: 100%">
    <v-responsive :aspect-ratio="1">
      <div
        v-if="productImages == null"
        style="
          background-color: #eee;
          height: 100%;
          background-position: center;
          background-size: cover;
        "
        :style="{ backgroundImage: 'url(\'/static/img/assets/_global/default-photo.png\')' }"
      ></div>
      <div
        v-else
        style="
          background-color: #eee;
          height: 100%;
          background-position: center;
          background-size: cover;
        "
        :style="{
          backgroundImage:
            'url(\'' +
            productImages[0] +
            '\'),url(\'/static/img/assets/_global/default-photo.png\')'
        }"
      ></div>
    </v-responsive>
    <v-card-text>
      {{ value.name }}
      <slot name="move"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      product: null
    }
  },
  mounted() {
    // this.product = this.value
  },
  computed: {
    productImages: function () {
      return this.value.photourl ? this.value.photourl.split(';;') : null
    }
  },
  methods: {
    onError(event) {
      $(event.target).attr('src', '/static/img/assets/_global/default-photo.png')
      // this.$set(this.productImages, 0, '/static/img/assets/_global/default-photo.png')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SortProductItem.vue